// 2021-06-20 CHP Change config from config to static/config in order to change it anytime
// 2022-01-01 CHP 增加vue-meta

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Meta from 'vue-meta' // 2022-01-01 CHP 增加，用于SEO
import App from './App'
import router from './router'
import store from './store/store'

// import axios from 'axios'
import 'mint-ui/lib/style.css'
import '@/assets/fonts/font.css'
// import {Toast} from 'mint-ui'
import 'element-ui/lib/theme-chalk/index.css'
import {Carousel, CarouselItem, Card} from 'element-ui'
import {LogUtils, isMobileAgent, checkApkVersion, Storage} from '@/utils'
import VueI18n from 'vue-i18n'
import plusExtends from '@/config/plus.js'
import VueLazyload from 'vue-lazyload'
import {DatetimePicker} from 'mint-ui'
import './global.css'
Vue.prototype.$plus = plusExtends
Vue.component(DatetimePicker.name, DatetimePicker)
// axios.defaults.baseURL = config.baseURL // 2021-06-20 C0025 Add
Vue.prototype.$getRemainingTimeToday = function () {
  const now = new Date()
  const endOfDay = new Date()
  endOfDay.setHours(23, 59, 59, 999)

  let diff = endOfDay - now

  // 处理跨日情况
  if (diff < 0) {
    endOfDay.setDate(endOfDay.getDate() + 1)
    diff = endOfDay - now
  }

  // 将毫秒转换为时分秒
  const totalSeconds = Math.floor(diff / 1000)
  const hours = Math.floor(totalSeconds / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = totalSeconds % 60

  // 格式化为两位字符串并拆分为单个字符
  const format = (num) => {
    const str = num.toString().padStart(2, '0')
    return [str[0], str[1]]
  }

  const [hour1, hour2] = format(hours)
  const [minute1, minute2] = format(minutes)
  const [second1, second2] = format(seconds)

  // 返回拆分后的各个数字
  return {
    hour1,
    hour2,
    minute1,
    minute2,
    second1,
    second2
  }
}
Vue.config.productionTip = false

// 2022-03-05 CHP 增加引入Carousel和CarouselItem
Vue.use(Carousel).use(CarouselItem).use(Card).use(VueI18n)

const i18n = new VueI18n({
  locale: localStorage.getItem('locale') ? localStorage.getItem('locale') : 'EN', // todo 使用版本
  fallbackLocale: 'EN',
  messages: { // todo 配置不同版本
    'EN': require('./assets/locale/en-US.js'),
    'IN': require('./assets/locale/hi-IN.js')
  }
})

Vue.use(VueLazyload, {})

// 定义 Facebook Pixel 初始化函数
function initFacebookPixel (pixelId) {
  // Facebook Pixel 初始化代码
  (function (f, b, e, v, n, t, s) {
    if (f.fbq) return
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    }
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
    t = b.createElement(e)
    t.async = true
    t.src = v
    s = b.getElementsByTagName(e)[0]
    s.parentNode.insertBefore(t, s)
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js')

  // 初始化 Pixel
  window.fbq('init', pixelId)
}

// 动态选择 Pixel ID
function determinePixelId () {
  // Pixel ID
  const cid = localStorage.getItem('cid')
  // 根据 cid 选择 Pixel ID
  if (cid && cid === '9af1ep') {
    return '470730042764100'
  } else if (cid && cid === 'kfz4qy') {
    return '1238628657793235'
  }
  return '470730042764100'
}

/***
 * Execute something when enter each router
 * ......
 * 2021-06-08 CHP Add logic to send visit log to server
 * 2021-09-06 CHP 修改获取QueryString参数的方法，用to.query.xxx
 * 2021-10-24 LBL 如果是PC浏览器，跳转到web
 * 2021-10-25 CHP 根据用户特性决定用户所属国家版本
 * 2021-10-31 CHP 增加setShowInternationDDL判断是否需要显示国家列表
 * 2021-11-29 CHP 梳理IsAppCid判断逻辑
 */
router.beforeEach(async (to, from, next) => {
  if (window !== window.top) {
    try {
      window.top.$gameClose() // 发现被嵌套了就调用top的关闭方法
    } catch (e) {
      console.log('can\'t game close', e)
    }
  }
  if (!isMobileAgent()) {
    let fullPath = to.fullPath
    let index = fullPath.indexOf('?')
    let params = fullPath.substring(index)
    if (to.query.rv) {
      if (location.hostname.startsWith('uat')) {
        window.location.href = 'https://uat.pgebet.com/login' + params
      } else if (location.hostname.startsWith('test')) {
        window.location.href = 'https://test.pgebet.com/login' + params
      } else {
        let firstDotIndex = location.hostname.toLowerCase().indexOf('.')
        let result = location.hostname.substring(firstDotIndex + 1)
        result = result.replace('/', '')
        window.location.href = 'https://www.' + result + '/login' + params
      }
    } else {
      if (location.hostname.startsWith('uat')) {
        window.location.href = window.location.href.replace('uat-app', 'uat')
      } else if (location.hostname.startsWith('test')) {
        window.location.href = window.location.href.replace('test-app', 'test')
      } else if (location.hostname.startsWith('app')) {
        window.location.href = window.location.href.replace('app', 'www')
      }
    }
  }
  // start 2021-7-30 C007 在Deposit页面
  document.getElementById('loading').style.display = 'none'
  // end 2021-07-30
  if (to.query.cid) {
    // 2022-02-20 CHP Cid统一转为小写
    let cidQ = to.query.cid.toLowerCase()
    // 2022-05-10 CHP 来自PartnerMatrix的cid为xxxx_xxxx,只取前半部分
    if (cidQ.indexOf('_') > 0) {
      let cidQL = cidQ.split('_')
      if (cidQL.length > 0) {
        cidQ = cidQL[0]
      }
    }
    localStorage.setItem('cid', cidQ)
  } else if (!localStorage.getItem('cid') && window.location.hostname.indexOf('pgebet.club') > -1) { // #885 配合直连 分配域名&渠道 --hh2e98 pgebet.club
    localStorage.setItem('cid', 'hh2e98')
  }
  if (to.query.af) {
    localStorage.setItem('af', to.query.af)
  }
  let cid = localStorage.getItem('cid') // 注：从localstorage取出cid）

  // 初始化 Facebook Pixel
  const pixelId = determinePixelId()
  initFacebookPixel(pixelId)

  // START 2021-11-29 CHP 重新梳理AppCid判断逻辑
  if (cid) {
    // 2021-11-19 WXJ 增加是否是app渠道开头的应用
    const isAppCid = typeof (cid) === 'string' && cid.startsWith('app')
    localStorage.setItem('isAppCid', isAppCid)
    store.commit('setIsAppCid', isAppCid)
  } else {
    localStorage.setItem('isAppCid', false)
    store.commit('setIsAppCid', false)
  }
  // if (localStorage.getItem('isAppCid') === 'false') {
  //   localStorage.setItem('finishUserGuide', true)
  //   store.commit('setFinishUserGuide', true)
  // }
  // END 2021-11-29

  if (to.query.v) {
    localStorage.setItem('apkV', to.query.v)
  } else {
    // localStorage.setItem('apkV', '1.0.0')
  }
  // 2022-06-21 CHP 重构国家版本语言设置
  setInternation()

  // 2022-06-21 CHP 重构LogVisit代码
  LogUtils.logVisit(location, to)
  // document.addEventListener('visibilitychange', logHandler)
  let visibleCallback = function (ev) {
    if (!document.hidden || ev.type === 'DOMContentLoaded') {
      checkApkVersion()
      ev.stopPropagation()
      return false
    }
  }
  document.addEventListener('DOMContentLoaded', visibleCallback)
  // END 2021-12-14 WXJ 增加切换Bonus显示

  // 谷歌统计
  window.gtag('config', 'G-7BVS71WNE2', {'page_path': location.pathname})
  window.gtag('event', 'Visits', {
    'event_category': location.pathname,
    'event_label': cid
  })

  // 如果路由有meta.title，则更新页面标题
  if (to.meta.title) {
    document.title = to.meta.title
  } else {
    document.title = 'pgebet01.com – Best Online Casino & Sports Betting in India'
  }

  // 更新其他meta信息（例如 description, keywords）
  if (to.meta.description) {
    const description = document.querySelector('meta[name="description"]')
    if (description) {
      description.setAttribute('content', to.meta.description)
    }
  } else {
    const description = document.querySelector('meta[name="description"]')
    if (description) {
      description.setAttribute('content', 'Play Teen Patti, Andar Bahar, Blackjack & Roulette at PGEBet. Enjoy live cricket betting, slots & sports betting with instant UPI deposits. Claim your welcome bonus today!')
    }
  }
  if (to.meta.keywords) {
    const keywords = document.querySelector('meta[name="keywords"]')
    if (keywords) {
      keywords.setAttribute('content', to.meta.keywords)
    }
  } else {
    const keywords = document.querySelector('meta[name="keywords"]')
    if (keywords) {
      keywords.setAttribute('content', 'Online Casino India,IPL Betting,Real Money Games,Welcome Bonus India.')
    }
  }

  if (to && to.name && to.name.toLowerCase() !== 'home' && to.name.toLowerCase() !== 'login') {
    LogUtils.fbListener(to.name)
  }
  if (to && to.name && to.name.toLowerCase() === 'home' && to.query && to.query.utm_source) {
    try {
      let userId = null
      const jsonString = JSON.stringify(to.query)
      const userInfo = JSON.parse(localStorage.getItem('userInfo'))
      if (userInfo) {
        userId = userInfo.UserId
      }
      const param2 = await LogUtils.getVisitorCode()
      const param3 = jsonString
      localStorage.setItem('utm_source', jsonString)
      LogUtils.saveUserEventParams('utm_source', userId, 0, param2, param3)
    } catch (e) {
    }
  }
  next()
})

/****
 * 页面路由切换完成
 * 2021-07-02 C007 Create
 */
router.afterEach((to, from) => {
  // 性能规范处理
  // 获取当前页面的 URL（去掉查询参数等）
  const canonicalUrl = window.location.origin + to.fullPath

  // 查找页面中的 <link rel="canonical"> 标签
  let canonicalLink = document.querySelector("link[rel='canonical']")

  if (canonicalLink) {
    // 如果已存在 <link rel="canonical"> 标签，则更新其 href 属性
    canonicalLink.href = canonicalUrl
  } else {
    // 如果没有 <link rel="canonical"> 标签，则创建一个并添加到 <head> 中
    canonicalLink = document.createElement('link')
    canonicalLink.setAttribute('rel', 'canonical')
    canonicalLink.setAttribute('href', canonicalUrl)
    document.head.appendChild(canonicalLink) // 将新的标签添加到 head 中
  }
  if (localStorage.getItem('hasNewVersion') === '1') {
    localStorage.removeItem('hasNewVersion')
  }
})

/***
 * 设置国家版本
 * 2022-06-21 CHP 重构
 * 2023-05-24 WXJ 新需求
 */
const setInternation = function () {
  let locale = Storage.getExpire('locale')

  if (!locale) {
    locale = navigator.language.toUpperCase()
    if (locale === 'HI') {
      locale = 'IN'
    }
    if (locale !== 'EN' && locale !== 'IN') {
      locale = 'EN'
    }
    Storage.setExpire('locale', locale, 7 * 24 * 60 * 60)
  } else {
    locale = Storage.getExpire('locale')
    Storage.setExpire('locale', locale, 30 * 24 * 60 * 60)
  }
  let internation = 'IN'
  if (locale === 'IN') {
    internation = 'IN'
  }
  store.commit('setInternation', internation)
  // store.commit('setInternationName', res.InternationName)
  store.commit('setLocale', locale)
  i18n.locale = locale
}

// 全局自定义指令，用于点击事件的冷却时间 ytw.20260109
Vue.directive('cool', {
  bind: function (el, binding) {
    // 从指令参数中获取冷却时间，如果没有提供，则默认为 1000 毫秒
    let time = binding.arg !== undefined ? binding.arg : 1000
    let clickable = true

    el.addEventListener('click', function () {
      if (clickable) {
        clickable = false
        setTimeout(function () {
          clickable = true
        }, time)
        // 触发绑定的方法
        binding.value()
      }
    })
  }
})

/***
 * 检查用户7天送状态
 * 2022-06-21 CHP 重构
 * 2022-11-24 HHY 去掉使用state.finishUserGuide
 */
Vue.use(Meta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
}) // 2022-01-01 CHP 增加，用于SEO

/***
 * 非顶层关闭游戏iframe
 * 2024-05-27 YTW
 */
Vue.prototype.$gameClose = function () {
  store.commit('setGameInfo', {})
  store.commit('setShowGame', false)
}
window.$gameClose = Vue.prototype.$gameClose

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js